import * as t from 'io-ts';

import {makeEnumRuntimeType} from '../api/apiTypes';

/*
 * Base Runtime type.
 */

export enum TablePaginationTypesEnum {
  OFFSET = 'OFFSET',
  TOKEN = 'TOKEN',
}

const RTableBasePaginationData = t.type({
  type: makeEnumRuntimeType(TablePaginationTypesEnum),
  canLoadMore: t.boolean,
});

/*
 * Runtime types.
 */

const RTableTokenPaginationDataDirty = t.intersection([
  RTableBasePaginationData,
  t.type({
    type: t.literal(TablePaginationTypesEnum.TOKEN),
  }),
  t.partial({
    token: t.string,
  }),
]);

const RTableOffsetPaginationDataDirty = t.intersection([
  RTableBasePaginationData,
  t.type({
    type: t.literal(TablePaginationTypesEnum.OFFSET),
    offset: t.number,
  }),
]);

/*
 * Type.
 */

export interface TableTokenPaginationDataModel extends t.TypeOf<typeof RTableTokenPaginationDataDirty> {}
export const RTableTokenPaginationData = t.clean<TableTokenPaginationDataModel>(
  RTableTokenPaginationDataDirty as any,
);

export interface TableOffsetPaginationDataModel extends t.TypeOf<typeof RTableOffsetPaginationDataDirty> {}
export const RTableOffsetPaginationData = t.clean<TableOffsetPaginationDataModel>(
  RTableOffsetPaginationDataDirty as any,
);

export type TablePaginationDataModel = TableTokenPaginationDataModel | TableOffsetPaginationDataModel;
